export default __webpack_public_path__ + "static/media/rfbin_33.7d01f773.png";